export enum MfsLoginMode {
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP',
  FORGOT_RESET = 'FORGOT_RESET',
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  USER_SUSPENDED = 'USER_SUSPENDED',
}
